var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m93.302 168.488c5.689-33.831 21.626-64.642 46.085-89.102 5.858-5.858 5.858-15.355 0-21.213-5.857-5.858-15.355-5.858-21.213 0-28.896 28.896-47.727 65.322-54.456 105.339-1.374 8.17 4.135 15.906 12.305 17.28 8.202 1.38 15.91-4.168 17.279-12.304z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.282 163.512c-6.729-40.017-25.561-76.443-54.456-105.339-5.856-5.858-15.354-5.858-21.213 0-5.858 5.857-5.858 15.355 0 21.213 24.459 24.46 40.396 55.271 46.085 89.102 1.378 8.191 9.134 13.676 17.279 12.305 8.17-1.375 13.679-9.111 12.305-17.281z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391 302.898v-106.898c0-60.767-40.359-112.277-95.678-129.153 16.628-29.81-5.02-66.847-39.322-66.847-34.28 0-55.963 37.014-39.322 66.847-55.319 16.876-95.678 68.386-95.678 129.153v106.898c-25.85 6.678-45 30.195-45 58.102v30c0 8.284 6.716 15 15 15h150v18.58c-17.459 6.192-30 22.865-30 42.42 0 24.813 20.187 45 45 45s45-20.187 45-45c0-19.555-12.541-36.228-30-42.42v-18.58h150c8.284 0 15-6.716 15-15v-30c0-27.907-19.15-51.424-45-58.102zm-135 179.102c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zm0-452c8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15 6.729-15 15-15zm0 61c57.897 0 105 47.103 105 105v105h-210v-105c0-57.897 47.103-105 105-105zm150 285h-300v-15c0-16.542 13.458-30 30-30h240c16.542 0 30 13.458 30 30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.cd5b876eff3224e1f7f1c5940bcfe674.svg";
export { ForwardRef as ReactComponent };